import PlaneAction from "./PlaneAction.js";

export default class ContinueWhenReached extends PlaneAction {
    constructor(planeId) {
        super(planeId);
    }

    execute() {}

    isComplete() {
        const planeState = this.getState();
        return planeState.heading === planeState.target.heading &&
            planeState.altitude === planeState.target.altitude;
    }
}

